<template>
  <el-container>
    <el-header style="height: 70px;background-color: #FFFFFF">
      <div class="header-info">
        <img class="header-logo" src="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/logo-s.png">
        <a class="company-name">广东良方药业有限公司</a>
        <div class="info-navi">
          <ul>
<!--            <li>-->
<!--              <el-link class="navi-link" href="/hy-mic-sy/home" :underline="false">首页</el-link>-->
<!--            </li>-->
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/news" :underline="false">行业资讯</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/about" :underline="false">关于我们</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/contactUs" style="color: #0270FF" :underline="false">联系我们</el-link>
            </li>
          </ul>
        </div>
      </div>
    </el-header>
    <el-main style="margin: 0 auto;padding: 0;width: 1200px; padding-top: 10px;padding-bottom: 20px">
      <div class="main-banner">
        <el-carousel :interval="4000" height="400px" indicator-position="none">
          <el-carousel-item v-for="item in banners" :key="item.name" style="background-color: #FFFFFF">
            <el-image :src='item.url'></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="contactWay" style="margin-top: 30px;width: 1200px">
        <img src="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/Frame%20427318973.jpg">
      </div>
      <div class="addr" style="margin-top: 20px;">
        <img src="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/address.png" style="height: 500px">
      </div>
    </el-main>
    <el-footer style="height: 70px;padding-top: 40px">
      <div class="footer-info">
        <p style="line-height: 25px">
          版权所有©广东良方药业有限公司 |
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/xinxizheng.jpg" target="_blank">
            互联网药品信息服务资格证书编号(粤)-经营性-2020-0099
          </a> <br>
          ICP主体备案号：
          <a href="https://beian.miit.gov.cn/" target="_blank">
            粤ICP备2022011696号-1
          </a><br>
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/yinyezhizhao.jpg" target="_blank">营业执照副本</a>
        </p>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import Login from "@/views/login/LoginApp";

export default {
  data() {
    component:{
      Login
    }
    return {
      activeName: 'first',
      banners: [
        {
          name: 'banner1',
          url: 'https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/Frame%203577.jpg'
        }
      ],
      itemBanners: [
        {name: 'banner1', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file24FDEkGnat.jpg'},
        {name: 'banner2', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileD5pHJsc8at.jpg'},
        {name: 'banner3', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileDDwnrtifzD.jpg'}
      ]
    }
  },
  methods: {}
}
</script>

<style>

.product-img img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.content-tiny-program-info span {
  display: inline-block;
  margin-left: 10px;
  font-size: 18px;
}

.content-tiny-program-info img {
  height: 25px;
  width: 25px;
  line-height: 30px;
}

.second-banner img {
  width: 700px;
  height: 350px;
}

.footer-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
}


ul {
  display: flex;
  list-style: none;
  padding: 0;
  line-height: 40px;
  height: 70px;
  float: right;
  margin-right: 50px;
}

li {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-left: 40px;
  line-height: 70px;
}

.info-navi {
  float: right;
  width: 750px;
  height: 70px;
  text-align: right;
}

.main-banner {
}


.header-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.header-logo {
  width: 89px;
  height: 60px;
  float: left;
}

.header-info .company-name {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
  float: left;
}
</style>
<style scoped>

</style>
